import React, { useContext } from 'react';
import { Icon, Heading, Text, ResponsiveContext, Box, colors, ButtonV2 } from '@alinta-digital/asg';
import { ErrorProps } from '.';

export const Error: React.FC<ErrorProps> = ({
  desktopIcon,
  mobileIcon,
  header,
  bodyText,
  showButton,
  buttonText,
  buttonOnClick
}) => {
  const responsiveSize = useContext(ResponsiveContext);
  const isMobileBreakPoint = responsiveSize === 'xs';
  const isSmallToLargeDesktopBreakPoint = responsiveSize === 'md' || responsiveSize === 'lg';
  const containerMargin = isMobileBreakPoint ? '48px' : '128px';
  return (
    <Box data-testid="errorContainer" margin={{ top: containerMargin, bottom: containerMargin }} height="100%">
      <Box direction="column" pad={{ horizontal: '10px' }}>
        <Box align="center">
          <Icon
            data-testid="icon"
            id="errorIcon"
            icon={isMobileBreakPoint ? mobileIcon : desktopIcon}
            width={isMobileBreakPoint ? '180px' : '360px'}
            height={isMobileBreakPoint ? '170px' : '340px'}
          />
        </Box>
        <Box>
          <Heading
            textAlign="center"
            data-testid="header"
            weight={700}
            margin={{
              top: 'medium',
              bottom: isSmallToLargeDesktopBreakPoint ? 'small' : 'xsmall'
            }}
          >
            {header}
          </Heading>
        </Box>
        <Box>
          <Text
            data-testid="bodytext"
            margin={{ bottom: 'medium' }}
            size={isMobileBreakPoint ? 'small' : '22px'}
            lineHeight={isMobileBreakPoint ? 'small' : '34px'}
            weight={300}
            color={colors.tertiaryText.light}
            textAlign="center"
          >
            {bodyText}
          </Text>
        </Box>
        {showButton && (
          <Box align="center" pad={{ horizontal: isMobileBreakPoint ? '30px' : '0' }}>
            <ButtonV2
              data-testid="btn"
              label={buttonText}
              secondary
              onClick={buttonOnClick}
              width={isMobileBreakPoint ? '100%' : '260px'}
            ></ButtonV2>
          </Box>
        )}
      </Box>
    </Box>
  );
};
